import Cookies, { CookieAttributes } from 'js-cookie';

export const useCookie = (
  name: string
): [
  string | undefined,
  (name: string, value: string | object, options?: CookieAttributes) => void
] => {
  const isBrowser = typeof window !== 'undefined';
  const cookie = isBrowser ? Cookies.get(name) : undefined;

  return [cookie, Cookies.set];
};
